/** Dev HTTPS URL for PWA install (HTTP :8888 cannot install in Chrome). */
export const DEV_PWA_SECURE_ORIGIN = 'https://15-206-221-200.nip.io';
export const DEV_PWA_SECURE_LOGIN_URL = `${DEV_PWA_SECURE_ORIGIN}/login`;

export const isInsecureDevOrigin = () => {
  if (typeof window === 'undefined') return false;
  return window.location.protocol === 'http:';
};

export const isSecureContext = () => {
  if (typeof window === 'undefined') return false;
  return window.isSecureContext === true;
};
